<template>
  <m-dialog ref="dlgImport" :fullscreen="false" :btnreset="false" title="Import Data Organisasi" :action="false">
    <v-row class row fill-height align="center" justify="center">
      <v-col cols="12" md="12" sm="12">
        <v-alert dense text type="info" class="body-2 my-5">
          <v-row align="center">
            <v-col col="12" md="8" style="font-weight: normal">
              Untuk unggah data pola jam kerja menggunakan file excel, maka silakan mengunduh template berikut ini
            </v-col>
            <v-col col="12" md="4">
              <v-btn color="info" depressed small @click="onDownload">
                <v-icon left>mdi-download</v-icon>
                Unduh Template
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>

        <v-card flat>
          <v-card-text>
            <v-alert v-if="messages.length" color="red" dense text>
              <ul>
                <li v-for="msg in messages" :key="msg">{{ msg }}</li>
              </ul>
            </v-alert>
            <span class="primary--text">Pilih Tenant</span>
            <v-select
              v-model="form.kode_tenant"
              dense
              outlined
              placeholder="Pilih Tenant"
              item-text="nama"
              item-value="no_reg"
              :items="tenants"
            >
              <template v-slot:item="{ item }">
                {{ item.nama }} &nbsp; <span class="grey--text caption"> ({{ item.no_reg }})</span>
              </template>
            </v-select>
            <div> Silakan unggah file dengan format yang telah ditentukan </div>
            <v-file-input
              v-model="file"
              prepend-icon=""
              append-icon="mdi-file-excel"
              accept=".xlsx,.xls"
              dense
              outlined
              placeholder="Pilih file dengan format (.xlsx dan .xls)"
              show-size
              :hint="`Jenis file unggahan dengan format (.xlsx dan .xls) maks ${roundDecimal(max / 1000).toFixed(
                1
              )} MB`"
              :rules="[
                (value) =>
                  !value ||
                  (value && value.size < roundDecimal(max * 1000)) ||
                  'File yang Anda pilih melebihi kapasitas maksimum!',
              ]"
              persistent-hint
            >
            </v-file-input>
          </v-card-text>
          <v-divider class="mb-5"></v-divider>
          <v-card-actions>
            <v-spacer />
            <div>
              <v-btn :disabled="!allowUpload" color="primary" @click="onUpload" class="mr-3">Unggah</v-btn>
              <v-btn color="red" dark @click="onClose">Tutup</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
export default {
  name: 'ImportKonfigurasi',

  props: {
    max: {
      type: Number,
      default: 1500,
    },
    tenants: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showForm: true,
      loading: false,
      defUser: {
        email: null,
      },
      form: {},
      file: null,
      messages: [],
      organisasi: '',
    }
  },

  computed: {
    allowUpload() {
      if (!this.file) return false
      if (!this.form.kode_tenant) return false
      return this.file && this.file.size < this.roundDecimal(this.max * 1000)
    },
  },

  methods: {
    // eslint-disable-next-line
    open() {
      return this.$refs.dlgImport.open()
    },

    reset() {
      this.file = null
      this.form = {}
      this.messages = []
    },

    onDownload() {
      this.$emit('download')
    },

    onClose() {
      this.$refs.dlgImport.dialog = false
    },

    onUpload() {
      this.messages = []
      const formData = new FormData()

      if (!this.form.kode_tenant) {
        this.$error('Harap pilih tenant terlebih dahulu')
        return
      }

      if (this.allowUpload) {
        formData.append('file', this.file)
        formData.append('kode_tenant', this.form.kode_tenant)
      }

      this.$store
        .dispatch('akses/importOrganisasi', {
          params: formData,
        })
        .then((res) => {
          const data = (res && res.data) || {}
          if (res.status === false) {
            this.messages = (data && data.info) || []
          } else {
            this.$emit('reload')
            this.onClose()
            this.$info('Data Organisasi berhasil di import')
          }
        })
    },

    roundDecimal(number) {
      return Math.round((number + Number.EPSILON) * 100) / 100
    },
  },
}
</script>
